/**
 * The Brain vault's on-disk layout, and nothing else.
 *
 * A Brain Action's send is an ordinary turn: it carries no durable operation, no git
 * baseline, and no verification pass, exactly as any other send does. The
 * per-turn checkpoint is what shows the user a Brain change and lets them
 * restore it.
 */
export const BRAIN_WORKSPACE_RELATIVE_PATH = ".afar-research/brain";
export const INITIAL_BRAIN_DIRECTORIES = ["raw", "wiki", "wiki/templates"] as const;

export const INITIAL_BRAIN_FILES = {
  "wiki/index.md": "# Brain\n\nDurable project knowledge lives here.\n",
  "wiki/log.md": "# Brain Log\n\n",
} as const;
